import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Header, ScrollToTop } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Benefits from "@/pages/Benefits";
import Booking from "@/pages/Booking";
import ServiceDetail from "@/pages/ServiceDetail";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Gallery from "@/pages/Gallery";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import { SEO } from "@/components/SEO";
import { ROUTE_SEO } from "@/seo/site";
import { AnalyticsConsent } from "@/components/AnalyticsConsent";

function RouteSEO() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/services/") || pathname.startsWith("/blog/")) return null;
  const meta = ROUTE_SEO[pathname] || {
    title: "Risi Wellness Limited",
    description: "Professional mobile massage and holistic wellness services from Risi Wellness Limited.",
    robots: "noindex, follow",
  };
  return <SEO {...meta} pathname={pathname} />;
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App">
        <BrowserRouter>
          <RouteSEO />
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/benefits" element={<Benefits />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/legal/:type" element={<Legal />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <AnalyticsConsent />
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
